import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.project.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-admin-project-item',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.project.item/view.scss */
/* src/app/page.admin.project.item/view.scss: no such file or directory */`],
})
export class PageAdminProjectItemComponent implements OnInit, OnDestroy {
    public updating: boolean = false;
    public id: string = '';
    public tab: string = 'info';
    public data: any = null;
    public hosts: any = [];
    public ip_list: any = [];
    public role: any = 'admin';
    public owner_info: any = {};

    private basePath: string = '/admin/project';
    private routerSub: any;

    // Owner 변경 콜백 객체 (공유 컴포넌트에 전달)
    public ownerChangeHandler: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'info';

        // 화살표 함수로 this 바인딩 보장
        this.ownerChangeHandler = {
            loadUsers: async () => {
                const res: any = await wiz.call("members", { project_id: this.id });
                if (res.code === 200) return res.data;
                return [];
            },
            change: async (newOwnerId: string) => {
                const res: any = await wiz.call("change_owner", {
                    project_id: this.id,
                    new_owner: newOwnerId
                });
                if (res.code === 200) {
                    await this.load();
                }
            }
        };
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");

        // WizRoute.segment 변경 감지: NavigationEnd 시 patternMatcher가 이미 segment를 갱신한 상태
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                const newTab = WizRoute.segment.tab || 'info';

                if (newId && newId !== this.id) {
                    this.id = newId;
                    this.tab = newTab;
                    await this.load();
                } else if (newTab !== this.tab) {
                    this.tab = newTab;
                    await this.service.render();
                }
            }
        });

        // tab 없이 접근 시 /info로 리다이렉트 (페이지 내 처리)
        if (!WizRoute.segment.tab) {
            this.service.href(`${this.basePath}/${this.id}/info`);
            return;
        }

        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        this.data = null;
        await this.service.render();

        if (this.id === 'new') {
            this.data = { name: '', category: '', params: [] };
            this.role = 'admin';
            this.ip_list = [];
            this.hosts = [];
            this.owner_info = {};
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href(this.basePath);
            return;
        }
        this.data = data.project;
        this.role = data.role;
        this.ip_list = data.ip_list;
        this.hosts = data.hosts;
        this.owner_info = data.owner_info || {};
        if (!this.data.params) this.data.params = [];
        await this.service.render();
    }

    public async update() {
        await this.service.render(this.updating = true);

        let pd = JSON.stringify(this.data);
        const { data } = await wiz.call("update", { data: pd });

        await this.service.sleep(1000);

        if (!data.id) {
            await this.service.render(this.updating = false);
            return;
        }

        if (this.id != data.id) {
            this.id = data.id;
            this.data = data;
            this.service.href(`${this.basePath}/${this.id}/${this.tab}`);
        }

        await this.service.render(this.updating = false);
    }
}

export default PageAdminProjectItemComponent;